(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["A-Plus-Banner-Section"] && !window.DesignMode) return;
  try {
    
  // Lazy loading images using lazysizes.js (make sure lazysizes.js is loaded in your theme)
  document.addEventListener('DOMContentLoaded', function() {
    var images = document.querySelectorAll('.lazyload');
    images.forEach(function(image) {
      image.classList.add('lazyload');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insta-celebrity"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Add interactive functionality to Instagram posts
  const likeBtns = document.querySelectorAll('.like-btn');
  const saveBtns = document.querySelectorAll('.save-btn');
  
  likeBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      this.style.color = this.style.color === 'rgb(237, 73, 86)' ? '#262626' : '#ed4956';
      
      // Add heart animation
      this.style.transform = 'scale(1.2)';
      setTimeout(() => {
        this.style.transform = 'scale(1)';
      }, 150);
    });
  });
  
  saveBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      this.style.color = this.style.color === 'rgb(237, 73, 86)' ? '#262626' : '#ed4956';
    });
  });
  
  // Add double-tap to like functionality on images
  const images = document.querySelectorAll('.instagram-image');
  images.forEach(img => {
    let tapCount = 0;
    img.addEventListener('click', function() {
      tapCount++;
      if (tapCount === 1) {
        setTimeout(() => {
          if (tapCount === 2) {
            // Double tap - trigger like
            const likeBtn = this.closest('.instagram-post').querySelector('.like-btn');
            likeBtn.style.color = '#ed4956';
            
            // Show heart animation
            const heart = document.createElement('div');
            heart.innerHTML = '❤️';
            heart.style.cssText = `
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) scale(0);
              font-size: 60px;
              pointer-events: none;
              z-index: 10;
              animation: heartPop 0.6s ease-out forwards;
            `;
            
            this.parentElement.style.position = 'relative';
            this.parentElement.appendChild(heart);
            
            setTimeout(() => heart.remove(), 600);
          }
          tapCount = 0;
        }, 300);
      }
    });
  });
});

// Add heart animation keyframes
const style = document.createElement('style');
style.textContent = `
  @keyframes heartPop {
    0% { transform: translate(-50%, -50%) scale(0); opacity: 0; }
    50% { transform: translate(-50%, -50%) scale(1.2); opacity: 1; }
    100% { transform: translate(-50%, -50%) scale(1); opacity: 0; }
  }
`;
document.head.appendChild(style);

  } catch(e) { console.error(e); }
})();
})();
